<script>
  import SupplierContactComponent from './SupplierContactComponent.svelte';

  export let representatives, edit, select;

</script>

{#each representatives as contact}
  <SupplierContactComponent
    {contact}
    selected={contact.selected}
    on:select={() => select(contact)}
    on:edit={() => edit(contact)}
  />
{/each}
